import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { ModalMetadata } from './types'

@Component
export class ModalContext extends Vue {
  private static singletonInstance: ModalContext
  private static modals = Vue.observable<{ [modalId: string]: ModalMetadata }>({})

  public static get instance(): ModalContext {
    if (!this.singletonInstance) {
      this.singletonInstance = new ModalContext()
    }
    return this.singletonInstance
  }

  reset(): void {
    Object.keys(ModalContext.modals).forEach((modalId) => {
      Vue.delete(ModalContext.modals, modalId)
    })
  }

  register(modalId: string): void {
    if (modalId in ModalContext.modals) return
    this.$set(ModalContext.modals, modalId, { active: false })
  }

  unregister(modalId: string): void {
    if (modalId in ModalContext.modals) {
      this.$delete(ModalContext.modals, modalId)
    }
  }

  getMetadata(modalId: string): Readonly<ModalMetadata> | undefined {
    return ModalContext.modals[modalId]
  }

  setMetadata(modalId: string, metadata: Partial<ModalMetadata>): void {
    this.$set(ModalContext.modals, modalId, metadata)
  }
}

export default ModalContext
